import Api from 'api/api';

class LocaleApi {
    saveLocale(locale) {
        return Api.getLocalNoSentry('/locale/save/' + locale);
    }
}

export default new LocaleApi();
